import httpInstance from "../httpInstance";

export const putUserType = async (jwtToken: string, userId: number, userName: string, userLastName: string, userType: number) => {
    let res: any;
    const endpoint = `user/${userId}/`;

    const config = {
        headers: {
            Authorization: `${jwtToken}`,
        }
    };

    const data = {
        name: `${userName}`,
        lastname: `${userLastName}`,
        user_type: `${userType}`
    };

    await httpInstance.put(endpoint, data, config)
        .then((data) => {
            res = data;
        })
        .catch((error) => {
            res = error.response;
        });

    return res;
}

export const putDeletedStatus = async (jwtToken: string, userEmail: string) => {
    let res: any;
    const endpoint = `user/unDeleteAccount/`;

    const config = {
        headers: {
            Authorization: `${jwtToken}`,
        }
    };

    const data = {
        email: `${userEmail}`,
    };

    await httpInstance.post(endpoint, data, config)
        .then((data) => {
            res = data;
        })
        .catch((error) => {
            res = error.response;
        });

    return res;
}

export const putBlockedStatus = async (jwtToken: string, userEmail: string, activate: boolean) => {
    let res: any;
    const endpoint = `user/${!activate ? 'reactivate' : 'deactivate'}/`;

    const config = {
        headers: {
            Authorization: `${jwtToken}`,
        }
    };

    const data = {
        email: `${userEmail}`,
    };

    await httpInstance.post(endpoint, data, config)
        .then((data) => {
            res = data;
        })
        .catch((error) => {
            res = error.response;
        });

    return res;
}